export default __webpack_public_path__ + "static/media/Vambrace of Crimson Slaughter.57f64292.jpg";